<template>
  <v-dialog
      scrollable
      v-model="visible"
      max-width="900px"
      :fullscreen="fullscreen"
      :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-form v-model="formValid" ref="formRef" lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs10>
                <v-text-field
                    label="合同名称"
                    :rules="rules.required"
                    v-model="item.name"/>
              </v-flex>

              <v-flex xs2>
                <v-autocomplete
                    label="合同方"
                    required
                    clearable
                    :rules="rules.required"
                    v-model="item.ctraSide"
                    :items=ctraSideItems
                    @change="onCtraSideChange"
                />
              </v-flex>

              <v-flex xs12 sm8>
                <v-text-field
                    label="合同相对方"
                    :rules="rules.required"
                    v-model="item.ctraOrg"
                    persistent-hint
                />
              </v-flex>

              <v-flex xs4>
                <v-autocomplete
                    label="合同类型"
                    clearable
                    multiple
                    :rules="rules.requiredArray"
                    v-model="item.typeIds"
                    item-text="name"
                    item-value="dbid"
                    :items="typeItems"
                    @change="handleSingleSelect"
                />
              </v-flex>

              <v-flex xs2 sm2>
                <!--
                <v-text-field
                    label="承办人"
                    :rules="rules.required"
                    v-model="item.agent"/>
                -->
<!--                <x-user-select-form-->
<!--                    label="经办人"-->
<!--                    :rules="rules.required"-->
<!--                    v-model="agent"-->
<!--                    persistent-hint-->
<!--                />-->

                <x-select-user
                    label="承办人"
                    v-model="agent"
                    :rules="rules.required"
                    persistent-hint
                />
              </v-flex>

              <v-flex xs4 sm3>
                <v-autocomplete
                    label="承办单位"
                    clearable
                    :rules="rules.required"
                    v-model="item.deptId"
                    item-text="name"
                    item-value="dbid"
                    :items="deptItems"
                />
              </v-flex>

              <v-flex xs7 sm7>
                <v-text-field
                    label="经费来源"
                    append-icon="search"
                    @click:append="onSelectProj()"
                    v-model="item.fundSrc"
                    :disabled="disnableCtraSide"
                    hint="点击检索图标可查询并选择项目和经费卡，也可直接填写，直接填写的请注明项目类别和名称！"/>
              </v-flex>


              <v-flex xs4 sm4>
                <v-text-field
                    label="项目经费号"
                    :disabled="disnableCtraSide"
                    v-model="item.fundNum"/>
              </v-flex>

              <v-flex xs4 sm4>
                <v-text-field
                    label="采购项目号"
                    :disabled="disnableCtraSide"
                    v-model="item.projNum"/>
              </v-flex>

              <v-flex xs4 sm4>
                <v-text-field
                    label="合同金额(元)"
                    :rules="rules.amount"
                    v-model="item.amount"/>
              </v-flex>

              <v-flex xs4 sm4>
                <v-text-field
                    label="合同期限"
                    :rules="rules.required"
                    v-model="item.period"/>
              </v-flex>

              <v-flex xs4 sm4>
                <v-autocomplete
                    label="我校签约人"
                    clearable
                    :items="signatoryItems"
                    v-model="item.signatory"/>
              </v-flex>


              <v-flex xs4 sm4>
                <v-text-field
                    label="联系电话"
                    :rules="rules.required"
                    v-model="item.phone"/>
              </v-flex>

              <v-flex xs12>
                <v-autocomplete
                    label="是否纳入学校统一招标，合同文本与招投标文件内容一致，合同签订单位、金额与招标结果一致"
                    clearable
                    v-model="item.nrtyzb"
                    item-text="name"
                    item-value="value"
                    :rules="rules.required"
                    :items="binItems"
                />
              </v-flex>

              <v-flex xs12>
                <v-autocomplete
                    label="是否属于政府采购网上竞价（电商）采购项目，无中标通知书，合同模板为学校推荐文本"
                    clearable
                    v-model="item.wsjj"
                    item-text="name"
                    item-value="value"
                    :rules="rules.required"
                    :items="binItems"
                />
              </v-flex>

              <v-flex xs12>
                <v-textarea
                    label="合同标的（主要内容）"
                    :rules="rules.required"
                    v-model="item.content"
                ></v-textarea>
              </v-flex>

              <v-flex xs3>
                <v-text-field
                    label="校章用印数"
                    v-model="item.instSealNum"
                    :rules="rules.amount"
                    hint="如不需要此类用印，请输入0！"
                />
              </v-flex>

              <v-flex xs3>
                <v-text-field
                    label="法人章用印数"
                    v-model="item.corpSealNum"
                    :rules="rules.amount"
                    hint="如不需要此类用印，请输入0！"
                />
              </v-flex>

              <v-flex xs3>
                <v-text-field
                    label="技术合同章用印数"
                    v-model="item.techSealNum"
                    :rules="rules.amount"
                    hint="如不需要此类用印，请输入0！"
                />
              </v-flex>

              <v-flex xs3>
                <v-text-field
                    label="授权委托人章用印数"
                    v-model="item.prinSealNum"
                    :rules="rules.amount"
                    hint="如不需要此类用印，请输入0！"
                />
              </v-flex>

              <v-flex xs12>
                <x-uploader
                    label="附件列表"
                    :action="fileUri"
                    v-model="item.attachments"
                    :size="Number(20)"
                    :description="[
                  '单个附件大小不超过 20M.',
                  '推荐上传 PDF 格式文件.'
                ]"
                />
              </v-flex>
            </v-layout>
          </v-container>

          <v-container grid-list-md v-if="['dept_await', 'org_await','checked', 'returned'].find(it => it === item['statusId']) && roleId != 'DbdqbSexgAA'">
            <v-layout wrap class="pa-3" style="background-color: rgba(227,190,178,0.1)">
              <v-flex xs12>
                <span class="blue--text">承办单位意见，以下内容承办单位填写</span>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                    label="合同类别"
                    clearable
                    multiple
                    v-model="item.cateIds"
                    item-text="name"
                    item-value="dbid"
                    :items="cateItems"
                />
              </v-flex>

              <v-flex xs12 sm6>
                <v-autocomplete
                    label="是否已使用格式合同范本"
                    clearable
                    v-model="item.htfb"
                    item-text="name"
                    item-value="value"
                    :items="binItems"
                />
              </v-flex>

              <v-flex xs12 sm6>
                <v-autocomplete
                    label="是否已核查合同主体资质"
                    clearable
                    v-model="item.htztzz"
                    item-text="name"
                    item-value="value"
                    :items="binItems"
                />
              </v-flex>

              <v-flex xs12 sm6>
                <v-autocomplete
                    label="是否已核查合同文本内容"
                    clearable
                    v-model="item.htwbnr"
                    item-text="name"
                    item-value="value"
                    :items="binItems"
                />
              </v-flex>

              <v-flex xs12 sm6>
                <v-autocomplete
                    label="是否已核查法律风险条款"
                    clearable
                    v-model="item.flfxtk"
                    item-text="name"
                    item-value="value"
                    :items="binItems"
                />
              </v-flex>

              <v-flex xs12>
                <v-autocomplete
                    label="是否纳入学校预算，符合学校开支范围"
                    clearable
                    v-model="item.nrys"
                    item-text="name"
                    item-value="value"
                    :items="binItems"
                />
              </v-flex>

            </v-layout>
          </v-container>

          <v-container grid-list-md v-if="['org_await','checked', 'returned'].find(it => it === item['statusId']) && roleId != 'DbdqbSexgAA'">
            <v-layout wrap class="pa-3" style="background-color: rgba(37,87,96,0.1)">
              <v-flex xs12>
                <span class="blue--text">归口管理部门意见, 以下内容由科技院填写</span>
              </v-flex>

              <v-flex xs12 sm6>
                <v-autocomplete
                    label="合同订立的依据是否存在"
                    clearable
                    multiple
                    v-model="item.dlyj"
                    item-text="name"
                    item-value="value"
                    :items="binItems"
                />
              </v-flex>

              <v-flex xs12 sm6>
                <v-autocomplete
                    label="合同当事人是否适格"
                    clearable
                    v-model="item.dsrsh"
                    item-text="name"
                    item-value="value"
                    :items="binItems"
                />
              </v-flex>

              <v-flex xs12 sm6>
                <v-autocomplete
                    label="合同的签订材料是否完备齐全"
                    clearable
                    v-model="item.clqb"
                    item-text="name"
                    item-value="value"
                    :items="binItems"
                />
              </v-flex>

              <v-flex xs12 sm6>
                <v-autocomplete
                    label="合同内容是否违反国家政策或者学校规定"
                    clearable
                    v-model="item.wfgd"
                    item-text="name"
                    item-value="value"
                    :items="binItems"
                />
              </v-flex>

              <v-flex xs12>
                <v-autocomplete
                    label="是否采用格式合同范本或者是否对格式合同范本主要条款作实质性变更"
                    clearable
                    v-model="item.cyhtfb"
                    item-text="name"
                    item-value="value"
                    :items="binItems"
                />
              </v-flex>


            </v-layout>

          </v-container>

        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
        <v-btn color="primary" @click.native="onSave">保存
        </v-btn>
      </v-card-actions>

      <!--@ok="(it) => Object.assign(item,it)"-->
      <x-select-proj
        v-model="select"
        @ok="handleProjSelect"
        :leader-id = "leaderId"
      >
      </x-select-proj>
    </v-card>
  </v-dialog>
</template>
<script>

import mixin from '@/mixin'

//import XUserSelectForm from '@/components/global/UserSelectForm'
import XSelectUser from '@/components/ol_ctra/OlCtraUserSelect'
import XUploader from '@/components/global/Uploader'
import XSelectProj from '@/components/ol_ctra/SelectProj'
import {mapGetters} from "vuex";

const baseURI = '/api/ol-ctra/contract';
const typeURI = '/api/ol-ctra/type';
const cateURI = '/api/ol-ctra/cate';
const deptURI = '/api/syst/department';

export default {
  mixins: [mixin.edit(baseURI)],
  //components: {XUserSelectForm, XUploader, XSelectProj, XSelectUser},
  components: {XUploader, XSelectProj, XSelectUser},
  props:['userId'],
  data() {
    return {
      formValid: false,

      fileUri: '/api/ctra/file',

      item: {
      },

      freshItem: {
        typeIds: [],
        cateIds: [],
        name:"",   // 合同名称
        ctraSide: "",//合同方
        admin_dept_id:"",   // 主管部门外键
        dept_id:"",   // 承办单位外键
        status_id:"",   // 审核状态
        amount:"",   // 合同金额
        period:"",   // 合同期限
        note:"",   // 备注
        ctra_org:"",   // 对方单位
        dept_name:"",   // 承办单位名称
        proj_num:"",   // 采购项目号
        fund_num:"",   // 项目经费号
        signatory:"",   // 我校签约人
        fund_src:"",   // 经费来源
        agentId:"",   // 承办人外键
        agentName:"", // 承办人姓名
        phone:"",   // 联系电话
        content:"",   // 合同标的（主要内容）
        htfb:"T",   // 是否已使用格式合同范本
        htztzz:"T",   // 是否已核查合同主体资质
        htwbnr:"T",   // 是否已核查合同文本内容
        flfxtk:"T",   // 是否已核查法律风险条款
        nrys:"T",   // 是否纳入学校预算，符合学校开支范围
        nrtyzb:"",   // 是否纳入学校统一招标，合同文本与招投标文件内容一致，合同签订单位、金额与招标结果一致
        wsjj:"",   // 是否属于政府采购网上竞价（电商）采购项目，无中标通知书，合同模板为学校推荐文本
        dlyj:"T",   // 合同订立的依据是否存在
        dsrsh:"T",   // 合同当事人是否适格
        clqb:"T",   // 合同的签订材料是否完备齐全
        wfgd:"F",   // 合同内容是否违反国家政策或者学校规定
        cyhtfb:"T",   // 是否采用格式合同范本或者是否对格式合同范本主要条款作实质性变更
        instSealNum: "", //校章用印数
        corpSealNum: "",  //法人章用印数
        techSealNum: "",  //技术合同章用印数
        prinSealNum: "",  //授权委托人章用印数
      },

      agent: {},

      startDateMenu: false,
      startDate: null,

      endDateMenu: false,
      finishDate: null,

      leaderId: '',

      typeItems: [],
      cateItems: [],
      deptItems: [],
      signatoryItems: ["王华","那靖"],

      binItems: [{value: "T", name: "是"}, {value: "F", name: "否"}],
      ctraSideItems:[{value: 'J', text: '甲方'}, {value: 'Y', text: '乙方'}],

      disnableCtraSide: false,
      select: false,

      /**
       * 验证规则
       */
      rules: {
        required: [
          v => !!v || '必填项。'
        ],
        bidding: [
          v => (v === true || v === false) || '必填项。'
        ],
        normal: [
          v => !!v || '必填项。',
          v => (v && v.length <= 100) || '长度必须小于100个字符。'
        ],
        amount: [
          v => v !== null && v !== undefined && v !== '' || '必填项。',
          v => (v === 0 || (v && /^\d{1,10}?(.[0-9][0-9]?)?$/ig.test(v))) || '填写数字，小数点后最多保留2位。'
        ],
        email: [
          v => (!v || /^[\w.-]+@(?:[a-z0-9]+(?:-[a-z0-9]+)*\.)+[a-z]{2,3}$/ig.test(v)) || '邮箱格式不正确。'
        ],
        requiredArray: [
          v => Array.isArray(v) && v.length > 0 || '必填项。'
        ],

        startDate: [
          v => !!v || "必填项。",
          v => window.xutil.regexpDate().test(v) || '日期格式错误'
        ],
        finishDate: [
          v => !!v || "必填项。",
          v => (v && window.xutil.regexpDate().test(v)) || '日期格式错误',
          v => (v && v > this.item.startDate) || "截止日期必须晚于起始日期。"
        ]
      }
    }
  },

  created() {
    this.indstTypeLoading = true;
    this.axios.all([
      this.axios.get(deptURI, {params: {limit: 65535, disabled: 'F'}}),
      this.axios.get(typeURI, {params: {limit: 65535, disabled: 'F'}}),
      this.axios.get(cateURI, {params: {limit: 65535, disabled: 'F'}}),
    ]).then(
        this.axios.spread(
            (rspDept, rspType, rspCate) => {
              this.deptItems = rspDept.data.items;
              this.typeItems = rspType.data.items;
              this.cateItems = rspCate.data.items;
            }
        )
    )
  },

  watch: {
    "userId":function (v) {
      this.leaderId = v
    },

    "agent": function (v) {
      window.console.log("承办人变更")
      window.console.log(v)
      window.console.log("原来的用户ID")
      window.console.log(this.userId)
      if(v)
      {
        window.console.log("编辑")
        this.item.agentId = v.dbid;
        this.item.agentName = v.name;
        this.leaderId =  v.dbid

        // if (v && v.deptId) this.item.deptId = v.deptId;
        // if (v && v.phone) this.item.phone = v.phone;

        // ✅ 新增：从 deptRoles[0] 取 departmentId
        if (v && Array.isArray(v.deptRoles) && v.deptRoles.length > 0) {
          window.console.log(11)
          this.item.deptId = v.deptRoles[0].departmentId;
        } else {
          window.console.log(22)
          //this.item.deptId = null; // 或 ''，根据你的数据类型约定
        }

        if (v && v.phone) this.item.phone = v.phone;
        // this.item.fundSrc = '';
        // this.item.fundNum = '';
      }
      else
      {
        window.console.log("新建")
        this.item.fundSrc = '';
        this.item.fundNum = '';
      }
    },
    // "agent": function (v) {
    //   window.console.log("承办人变更", v);
    //
    //   // 如果 agent 为空，清空相关字段（可选）
    //   if (!v) {
    //     this.item.agentId = null;
    //     this.item.agentName = '';
    //     this.item.deptId = null;
    //     this.item.phone = '';
    //     if (!this.dbid) {
    //       this.item.fundSrc = '';
    //       this.item.fundNum = '';
    //     }
    //     return;
    //   }
    //
    //   // 无论新建还是编辑，都更新 agent 基础信息
    //   this.item.agentId = v.userId || v.dbid; // 注意字段名
    //   this.item.agentName = v.name;
    //
    //   // 更新部门和电话
    //   if (Array.isArray(v.deptRoles) && v.deptRoles.length > 0) {
    //     this.item.deptId = v.deptRoles[0].departmentId;
    //   } else {
    //     this.item.deptId = null;
    //   }
    //   this.item.phone = v.phone || '';
    //
    //   // 仅在新建时清空经费字段
    //   if (!this.dbid) {
    //     this.item.fundSrc = '';
    //     this.item.fundNum = '';
    //   }
    //   // 如果是编辑模式，不清空 fundSrc/fundNum（保留原值）
    // }
  },

    computed: {
      ...mapGetters(['funcIds', 'roleId']),
    },

  methods: {
    // mixin 加载数据后调用
    afterGetData(data) {
      window.console.log("9999")
      window.console.log(data)
      this.agent = {
        dbid: data.crtUserId,
        name: data.agentName
      }
      this.item.fund_src = data.fundSrc
    },

    onCtraSideChange() {
      if(this.item.ctraSide == "Y")
      {
        this.disnableCtraSide = true
      }
      else
      {
        this.disnableCtraSide = false
      }
    },

    onSelectProj() {
      this.select = true
    },

    handleProjSelect(selectedItem) {
      // 接收子组件传递的数据
      window.console.log(" 接收子组件传递的数据")
      this.item.fundSrc = ""
      this.item.fundNum = ""
      this.item.fundSrc = selectedItem.type.name +":  " + selectedItem.name
      this.item.fundNum = selectedItem.card.number
    },

    handleSingleSelect(selectedItems) {
      if (selectedItems.length > 1) {
        this.$set(this.item, 'typeIds', [selectedItems[selectedItems.length - 1]]);
      }
    },


  }
}
</script>
